import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Instagram } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function Header({ instagramHandle = "tamilperfumeguy_", instagramUrl, siteName = "tpg.decants" }) {
  const { totals, setOpen } = useCart();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const igHref = instagramUrl || `https://instagram.com/${instagramHandle}`;

  // Allow brand dot highlight for default name
  const [left, , right] = siteName.includes(".")
    ? [siteName.split(".")[0], ".", siteName.split(".").slice(1).join(".")]
    : [siteName, "", ""];

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0C0E14]/80 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <Link to="/" data-testid="site-logo" className="flex items-center gap-2 group">
          <span className="font-headings text-xl sm:text-2xl font-medium tracking-wide uppercase text-[var(--text-primary)] group-hover:text-[var(--brand-gold)] transition-colors">
            {right ? (
              <>
                {left}
                <span className="text-[var(--brand-gold)]">.</span>
                {right}
              </>
            ) : (
              left
            )}
          </span>
        </Link>

        <div className="flex items-center gap-2 sm:gap-6">
          <a
            href="/#about"
            data-testid="header-about-link"
            className="hidden sm:inline-block text-xs uppercase tracking-[0.2em] text-[var(--text-secondary)] hover:text-[var(--brand-gold)] transition-colors"
          >
            About
          </a>
          <a
            href={igHref}
            target="_blank"
            rel="noreferrer"
            data-testid="header-instagram-link"
            className="hidden sm:flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[var(--text-secondary)] hover:text-[var(--brand-gold)] transition-colors"
          >
            <Instagram size={16} />
            <span>@{instagramHandle}</span>
          </a>
          <a
            href={igHref}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            data-testid="header-instagram-icon"
            className="sm:hidden p-2 text-[var(--text-secondary)] hover:text-[var(--brand-gold)]"
          >
            <Instagram size={18} />
          </a>
          {!isAdmin && (
            <button
              data-testid="cart-trigger"
              onClick={() => setOpen(true)}
              className="relative p-2 text-[var(--text-primary)] hover:text-[var(--brand-gold)] transition-colors"
              aria-label="Open cart"
            >
              <ShoppingBag size={20} />
              {totals.count > 0 && (
                <span
                  data-testid="cart-badge"
                  className="absolute -top-0.5 -right-0.5 bg-[var(--brand-gold)] text-black text-[10px] min-w-4 h-4 px-1 flex items-center justify-center rounded-full font-bold"
                >
                  {totals.count}
                </span>
              )}
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
